import React, {useEffect, useState} from 'react';
import { Licitacion } from '../models/Licitacion';
import { OdooData } from '../models/OdooResponse';
import Config from '../config/default.json'
import ComponentLicitacionTable from './ComponentLicitacionTable'
import ComponentLicitacionForm from './ComponentLicitacionForm'
import './ComponentMain.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleRight, faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons'
import {Button} from 'react-bootstrap'
import { useLocation } from "react-router-dom";


const ComponentMain: React.FC = () =>{
  const [licitaciones, setLicitaciones]           = useState<Licitacion[]>([])
  const [licitFiltered, setLicitacionesFilter]    = useState<Licitacion[]>([])
  const [showForm, setShowForm]    = useState(false)
  const [disabledBtnPrev, setDisabledBtnPrev]    = useState(true)

  const { search }  = useLocation();
  const match_state = search.match(/state=(.*)/);
  const match_id    = search.match(/id=(.*)/);
  const state_params= match_state?.[1];
  const id_params   = match_id?.[1];
  const [offset, setOffset] = useState(0)

  const [licitSelected, setLicitacionSelected]    = useState<Licitacion>({id: "",
                                                                          name: "",
                                                                          type: "",
                                                                          title: "",
                                                                          fecha_hora_apertura: "",
                                                                          presupuesto_oficial: "",
                                                                          valor_pliego: "",
                                                                          pliego_y_decreteo_id:"",
                                                                          decreto_adjudicacion_id: "",
                                                                          decreto_de_aprt_id: "",
                                                                          state: "",
                                                                          inscripcion_ids:[],
                                                                          adjudicado_ids:[],
                                                                          fecha_hora_cierre:'',
                                                                          show_oferentes:false
                                                                       
                                                                        })

  useEffect(() => {
    setListPersona(offset, state_params!==undefined?state_params:"para_apertura");
  }, []);

  const setListPersona=(page:number, state:string)=>{
    let requestOptions = {
        method: 'POST',
        
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        
        body: JSON.stringify({'':'' }),    
    };
    var url = Config.Production.Host.url
    if(id_params){
      url = url + '/licitacion/' + id_params
    }else{
      url = url + '/licitaciones/'+state+'/'+page
    }
    fetch(url ,requestOptions).then((response) => {
        return response.json();
    }).then((respuesta: OdooData) => {
        let listWithFormat = setTimeFormat(respuesta.result)
        if (listWithFormat?.length){
          setLicitaciones(listWithFormat)
        }
        setLicitacionesFilter(respuesta.result)
        if (id_params){
          setLicitacionSelected(respuesta.result[0])
          setShowForm(true)
        }
      });   
    }
    const setFormLicitacion=()=>{
    }

    const setTimeFormat=(licitaciones: Licitacion[])=>{
      let res = licitaciones
 
      for (var i=0; i < res.length; i++){

        if (res[i].fecha_hora_apertura.length){

          let date_ej   = res[i].fecha_hora_apertura.split(' ')[0].split('-')
          
          let hora      = res[i].fecha_hora_apertura.split(' ')[1].split(':')
          let new_date  = new Date (res[i].fecha_hora_apertura.split(' ')[0]).toLocaleString('en-GB')
          let fecha     = new_date.split(",")[0].split("/")

          let _time     = new Date(Date.UTC(parseInt(fecha[2]),parseInt(fecha[1]),parseInt(fecha[1]),parseInt(hora[0]),parseInt(hora[1]),parseInt(hora[2]))).toLocaleString('en-GB')
          res[i].fecha_hora_apertura = date_ej[2]+ "/"+ date_ej[1]+ "/"+  date_ej[0]+ " "+ _time.split(',')[1]
        }
        if (res[i].fecha_hora_cierre.length){
          let date_ej = res[i].fecha_hora_cierre.split(' ')[0].split('-')
          
          let hora    = res[i].fecha_hora_cierre.split(' ')[1].split(':')
          let feha_input = res[i].fecha_hora_cierre.split(' ')[0]
         
          let new_date = new Date (feha_input).toLocaleDateString()
          let fecha   = new_date.split(",")[0].split("/")
         
          let _time   = new Date(Date.UTC(parseInt(fecha[2]),parseInt(fecha[1]),parseInt(fecha[1]),parseInt(hora[0]),parseInt(hora[1]),parseInt(hora[2]))).toLocaleString('en-US').split(',')[1]
          res[i].fecha_hora_cierre = date_ej[2]+ "/"+ date_ej[1]+ "/"+ date_ej[0] + " "+ _time
        }
       
      }
      return res
    }
    const table_view  = <ComponentLicitacionTable setlicitacionForm ={setFormLicitacion} licitaciones={licitFiltered}></ComponentLicitacionTable>
    const form_view   = <ComponentLicitacionForm  licitacion={licitSelected}></ComponentLicitacionForm>
    
    const actionPrev=()=>{
      setOffset(offset-50) //el siguiente inicio para buscar lics
      setDisabledBtnPrev(offset-50===0 ? true : false)
      setListPersona(offset-50, state_params!==undefined?state_params:"para_apertura")
    }
    const actionNext=()=>{
      setOffset(offset+50) //el siguiente inicio para buscar lics
      setDisabledBtnPrev(false)
      setListPersona(offset+50, state_params!==undefined?state_params:"para_apertura")
    }

    return(
        <div className="principal-div">
              {showForm?form_view:table_view}

              <Button onClick={actionPrev} className={disabledBtnPrev?'d-none m-1':'m-1'}>
                <FontAwesomeIcon className="form-ver-lic" icon={faArrowCircleLeft} /> Anterior
              </Button>
              <Button onClick={actionNext} className={licitFiltered.length<50?'d-none m-1':'m-1'}>
                Siguiente <FontAwesomeIcon className="form-ver-lic" icon={faArrowCircleRight} /> 
              </Button>
        </div>
    )
} 

export default ComponentMain;